import { useParams, Link } from 'react-router-dom';
import { useRef } from 'react';

import services from './servicesData';
import { trackEvent } from './analytics';

import bullet from './terrapene.png';
import './ServicePage.css';

function ServicePage() {
  const { id } = useParams();
  const service = services.find((s) => s.id === id);
  const formRef = useRef();

  if (!service) {
    return (
      <div className="service-page">
        <p>Service not found. <Link to="/">Return home</Link>.</p>
      </div>
    );
  }

   const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);
    const data = Object.fromEntries(formData.entries());
    data.service = service.title;

    try {
      const res = await fetch('/contact-form-handler.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        trackEvent({
          category: 'Form',
          action: 'Submit',
          label: `Service Form: ${service.title}`,
        });

        alert('Thank you! We’ve received your request and sent a confirmation.');
        formRef.current.reset();
      } else {
        alert('Submission failed. Please try again.');
      }
    } catch (err) {
      console.error('Submit error:', err);
      alert('Network error. Try again later.');
    }
  };

  return (
    <div className="service-page">
      <div className="service-content">
        <div className="service-image">
          <img
            src={service.heroImage}
            alt={service.heroAlt}
            className="hero-image"
          />
        </div>
        <div className="service-description">
          <h1>{service.title}</h1>
          <p className="short-description">{service.description}</p>
          <p className="long-description">{service.longDescription}</p>

          {service.tasks && service.tasks.length > 0 && (
            <ul className="task-list">
              {service.tasks.map((task, index) => (
                <li key={index}>
                  <img src={bullet} alt="" className="bullet-icon" />
                  <span>{task}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <section className="contact-form-section">
        <h2>Contact Us About {service.title}</h2>
        <p>Use the form below to so we will know how to help you with {service.title.toLowerCase()}.</p>

        <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
        {service.formQuestions?.map((q, index) => (
          <label key={index}>
            {q.label}
            {q.type === 'textarea' ? (
              <textarea
                name={q.name}
                placeholder={q.placeholder || ''}
                required={q.required || false}
              />
            ) : (
              <input
                type={q.type}
                name={q.name}
                placeholder={q.placeholder || ''}
                required={q.required || false}
              />
            )}
          </label>
        ))}
        <button type="submit">Submit</button>
      </form>
      </section>
      <Link to="/">← Back to Home</Link>
    </div>
  );
}

export default ServicePage;
